/**
 * Same normalization as backend `utils/normalizeMatchKey.js` and the
 * title/SKU duplicate checker. `.replace(/\s+/, " ")` rewrites only the first
 * whitespace run — keep that, or stored keys diverge from the checker.
 */
export function normalizeMatchKey(
  str: string | number | null | undefined
): string {
  if (!str) {
    if (str === 0) return "0";
    return "";
  }

  return `${str}`
    .toLowerCase()
    .replace(/\s+/, " ")
    .replace(/[^0-9a-z ]/g, "")
    .trim();
}

type NormalizedMatchFields = {
  item_title_normalized?: string;
  sku_normalized?: string;
};

/**
 * Copy `data` and refresh `item_title_normalized` / `sku_normalized` when the
 * source field is present. Cleared title/SKU normalize to `""`.
 */
export function stampNormalizedMatchFields<T extends Record<string, any>>(
  data: T
): T & NormalizedMatchFields {
  const next: T & NormalizedMatchFields = { ...data };
  if ("item_title" in next) {
    next.item_title_normalized = normalizeMatchKey(next.item_title);
  }
  if ("sku" in next) {
    next.sku_normalized = normalizeMatchKey(next.sku);
  }
  return next;
}
